import { render, staticRenderFns } from "./RequestDownloadableAttachment.vue?vue&type=template&id=3efd1b1f&scoped=true&"
import script from "./RequestDownloadableAttachment.vue?vue&type=script&lang=js&"
export * from "./RequestDownloadableAttachment.vue?vue&type=script&lang=js&"
import style0 from "./RequestDownloadableAttachment.vue?vue&type=style&index=0&id=3efd1b1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efd1b1f",
  null
  
)

export default component.exports